import { cn } from '@/app/utils'
import SmallArrowIcon from '@/assets/svg/SmallArrow.svg'

type Props = {
  className?: string
  title: string
  isExpanded: boolean
  onToggle: () => void
  ariaText: string
}

//TODO: в счетчиках переиспользовать
export const ExpandableHeader = ({
  className,
  title,
  isExpanded,
  onToggle,
  ariaText
}: Props) => (
  <>
    <button
      type="button"
      className={cn(
        'flex w-full items-center justify-between text-left',
        className
      )}
      aria-label={ariaText}
      aria-expanded={isExpanded}
      onClick={onToggle}
    >
      <span className="font-semibold text-20 xxs:text-16">{title}</span>
      <SmallArrowIcon className={isExpanded ? '' : '-scale-y-100'} />
    </button>
    <hr className="mb-16 mt-8 text-grey-20" />
  </>
)
